import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useGoogleMap } from '@react-google-maps/api'
import { isDev } from 'lib/env'
import { round } from 'lodash'

/* global google */

const useNearbyPlaces = ({
    center,
    types,
    searchRadius = 2000,
    devDebug = true,
    onPlacesChange,
}) => {
    const map = useGoogleMap()
    const [loading, setLoading] = useState([])
    const [places, setPlaces] = useState([])

    const lat = center && round(center.lat, 12)
    const lng = center && round(center.lng, 12)

    useEffect(() => {
        if (!center) return

        const callback = (results, status) => {
            setLoading(false)

            if (status === google.maps.places.PlacesServiceStatus.OK) {
                setPlaces(results)
                onPlacesChange && onPlacesChange(results)
            } else {
                setPlaces([])
                onPlacesChange && onPlacesChange([])
            }

            if (devDebug && isDev()) {
                // eslint-disable-next-line no-new
                new google.maps.Circle({
                    strokeColor: '#FF0000',
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: '#FF0000',
                    fillOpacity: 0.35,
                    map: map,
                    center: center,
                    radius: searchRadius,
                })
            }
        }

        const service = new google.maps.places.PlacesService(map)

        service.nearbySearch({
            location: center,
            radius: searchRadius,
            rankby: 'distance',
            types,
        }, callback)

        setLoading(true)
    }, [lat, lng]) // eslint-disable-line react-hooks/exhaustive-deps

    return [places, loading]
}

useNearbyPlaces.propTypes = {
    center: PropTypes.shape({
        lat: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired,
    }).isRequired,
    types: PropTypes.array.isRequired,
    searchRadius: PropTypes.number.isRequired,
    onPlacesChange: PropTypes.func.isRequired,
    devDebug: PropTypes.bool,
}

export default useNearbyPlaces
